
import { Link } from 'react-router-dom';

export default function Logistics() {
  return (
    <section id="logistics" className="py-24 bg-white">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="order-2 lg:order-1">
            <div className="inline-block bg-[#EDE8E4] text-[#6B6B6B] px-5 py-2 rounded-full text-sm font-semibold mb-4">
              LOGISTICS &amp; SUPPLY CHAIN
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-[#2C3E50] mb-8 leading-tight font-['Montserrat']">
              Mine to Plant.<br />Plant to <span className="text-[#8B1538]">Client.</span>
            </h2>
            <p className="text-base text-[#5A6C7D] leading-relaxed font-['Lato'] mb-8">
              TMI has partnered with local transporters to deliver raw material from mines and dumps to our Rustenburg processing plant. We are continually developing innovative and effective supply chain processes to meet our clients&apos; needs as a premium JIT (Just-In-Time) supplier.
            </p>

            <div className="space-y-5 mb-10">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-[#F5E6EA] rounded-lg flex-shrink-0 mt-1">
                  <i className="ri-route-line text-lg text-[#8B1538]"></i>
                </div>
                <div>
                  <h4 className="text-base font-bold text-[#2C3E50] font-['Montserrat'] mb-1">Raw Material Transport</h4>
                  <p className="text-sm text-[#5A6C7D] font-['Lato']">Coordinated trucking from multiple mine sites and dumps within 70–120km of our Rustenburg plant.</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-[#F5E6EA] rounded-lg flex-shrink-0 mt-1">
                  <i className="ri-time-line text-lg text-[#8B1538]"></i>
                </div>
                <div>
                  <h4 className="text-base font-bold text-[#2C3E50] font-['Montserrat'] mb-1">Just-In-Time Delivery</h4>
                  <p className="text-sm text-[#5A6C7D] font-['Lato']">Reliable JIT supply of quality chrome concentrate directly to clients from our processing site.</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-[#F5E6EA] rounded-lg flex-shrink-0 mt-1">
                  <i className="ri-global-line text-lg text-[#8B1538]"></i>
                </div>
                <div>
                  <h4 className="text-base font-bold text-[#2C3E50] font-['Montserrat'] mb-1">Local &amp; International Distribution</h4>
                  <p className="text-sm text-[#5A6C7D] font-['Lato']">Strategic alliances with local and international players ensure efficient distribution to global markets.</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-[#F5E6EA] rounded-lg flex-shrink-0 mt-1">
                  <i className="ri-shield-check-line text-lg text-[#8B1538]"></i>
                </div>
                <div>
                  <h4 className="text-base font-bold text-[#2C3E50] font-['Montserrat'] mb-1">Transporter Partnerships</h4>
                  <p className="text-sm text-[#5A6C7D] font-['Lato']">Trusted local transport partners ensuring consistent, safe delivery of chrome ore and concentrate.</p>
                </div>
              </div>
            </div>

            <Link
              to="/logistics"
              className="inline-flex items-center gap-2 border-2 border-[#8B1538] text-[#8B1538] bg-transparent px-10 py-4 rounded-lg font-semibold hover:bg-[#8B1538] hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Explore Logistics
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="order-1 lg:order-2 relative">
            <div className="rounded-2xl overflow-hidden shadow-[0_8px_32px_rgba(0,0,0,0.08)] w-full h-[520px]">
              <img
                src="https://public.readdy.ai/ai/img_res/380c2d57a54a155a151477b679b91c7d.jpg"
                alt="TMI Chrome Ore Transportation Northwest Province"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-4 -left-4 bg-white rounded-2xl p-5 shadow-xl border border-gray-100">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-[#F5E6EA] rounded-xl">
                  <i className="ri-truck-line text-xl text-[#8B1538]"></i>
                </div>
                <div>
                  <div className="text-xl font-bold text-[#2C3E50] font-['Montserrat']">70–120km</div>
                  <div className="text-xs text-gray-500 font-['Lato']">Supply Network Radius</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
